import actionTypes from '../secrets-web/src/store/actionTypes';
export default {
  ...actionTypes,

  SET_USER_PM: "SET_USER_PM"
}